export const errorMessages = {
  INVALID_TOKEN:
    "The link you followed is no longer valid, please apply for a new one below.",
  TOKEN_EXPIRED: "The token is expired. Please apply for a new one below.",
  UNKNOWN_ERROR: "Error occured.",
};
